// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AlertInfo from "@awc/XDL/Icons/AlertInfo";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import { wishListSharingStatusStyles } from "@insite/content-library/Components/WishListSharingStatus";
import Users from "@insite/mobius/Icons/Users";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

wishListSharingStatusStyles.privateTooltip = {
    mergeCss: true,
    iconProps: {
        css: css`
            margin-left: 0;
        `,
    },
};

wishListSharingStatusStyles.statusText = {
    size: fontConfig.fontSize.xSmall,
    lineHeight: fontConfig.lineHeight.xSmall,
    css: css`
        display: flex;
        align-items: center;
        gap: 6px;
        &&& > ${TypographyStyle} {
            font-size: ${fontConfig.fontSize.xSmall}px;
            line-height: ${fontConfig.lineHeight.xSmall};
            font-weight: ${fontConfig.weight.regular};
            color: ${color("text.link")};
            display: flex;
            align-items: center;
            gap: 6px;
            &:hover {
                color: ${color("common.ui8")};
            }
        }
    `,
};

wishListSharingStatusStyles.sharedIcon = {
    src: Users,
    size: 15,
    css: css`
        margin-right: 0;
        svg {
            color: ${color("primary.main")};
        }
        &:hover {
            svg {
                color: ${color("common.ui8")};
            }
        }
    `,
};

wishListSharingStatusStyles.autogeneratedTooltip = {
    mergeCss: true,
    iconProps: {
        css: css`
            margin-left: 0;
            margin-top: 3px;
        `,
    },
};
